import { Component } from "react";
import * as React from "react";

import TeamSiteImage from "../images/team_site.png";
import SharePointIcon from "../images/sharepoint_icon.png";
import TeamsIcon from "../images/teams_icon.png";
import CommunicationSiteImage from "../images/communication_site.png";
import LinkCardSmall from "./LinkCardSmall";

interface SiteTypeSelectionProps {
    onTeamClicked(): void;
    onCommunicationClicked(): void;
}

interface SiteTypeSelectionState {

}

export default class SiteTypeSelection extends Component<SiteTypeSelectionProps, SiteTypeSelectionState>
{
    public componentDidMount() {

    }

    public render() {

        return (
            <div className="help-box help-box--site-type-selection">

                <LinkCardSmall
                    title="Team Site"
                    description="e.g. Senior Leaders Team"
                    image={TeamSiteImage}
                    footerListItems={[
                        "Collaboration in small groups",
                        "Everyone can see and edit everything",
                        "Replace shared drives and folders",
                        "Available in both SharePoint and Teams",
                        "Includes online meetings and chat",
                        "You probably need a lot of these"]}
                    onClick={this.props.onTeamClicked} >

                    <img src={SharePointIcon}
                        className="help-box-item__image-container__icon"
                        style={{ left: -28, bottom: 0 }} />
                    <img src={TeamsIcon}
                        className="help-box-item__image-container__icon"
                        style={{ left: 50, bottom: -24 }} />

                </LinkCardSmall>

                <LinkCardSmall
                    title="Communication Site"
                    description="e.g. Policies"
                    image={CommunicationSiteImage}
                    footerListItems={[
                        "Lots of people will read content",
                        "Only a few people will edit content",
                        "Publish information",
                        "Only available in SharePoint",
                        "You will need fewer of these"]}
                    onClick={this.props.onCommunicationClicked} >

                    <img src={SharePointIcon}
                        className="help-box-item__image-container__icon"
                        style={{ left: -28, bottom: 0 }} />

                </LinkCardSmall>
            </div>
        );
    }
}